import * as PIXI from 'pixi.js';

import { APP_WIDTH, APP_HEIGHT } from '../../utils';

export default class LoadingSpinnerManager {
    constructor(width = APP_WIDTH, height = APP_HEIGHT) {
        this.container = new PIXI.Container();
        this.container.alpha = 0;
        this.container.label = 'loadingSpinnerContainer';

        const backgroundGraphics = new PIXI.Graphics();
        backgroundGraphics.label = 'backgroundGraphics';
        backgroundGraphics.rect(0, 0, width, height);
        backgroundGraphics.fill({ color: '#000000' });
        backgroundGraphics.alpha = 0.5;
        backgroundGraphics.eventMode = 'static';
        backgroundGraphics.on('pointerdown', event => {
            event.stopPropagation();
        });
        this.container.addChild(backgroundGraphics);

        const spinnerWhiteStroke = new PIXI.Graphics();
        spinnerWhiteStroke.label = 'spinnerWhiteStroke';
        spinnerWhiteStroke.arc(0, 0, 80, 0, Math.PI * 2);
        spinnerWhiteStroke.stroke({ color: 'rgba(255, 255, 255, 0.25)', width: 17 });
        spinnerWhiteStroke.x = width / 2;
        spinnerWhiteStroke.y = height / 2;
        // spinnerWhiteStroke.cacheAsTexture(true);
        this.container.addChild(spinnerWhiteStroke);

        const spinnerHighlight = new PIXI.Graphics();
        spinnerHighlight.label = 'spinnerHighlight';
        spinnerHighlight.arc(0, 0, 80, 0, Math.PI / 2);
        spinnerHighlight.stroke({ color: '#efa800', width: 17 });
        spinnerHighlight.x = width / 2;
        spinnerHighlight.y = height / 2;
        // spinnerHighlight.cacheAsTexture(true);
        this.container.addChild(spinnerHighlight);

        this.fadeInTimerFunction = ticker => {
            if (this.container.alpha < 1) {
                this.container.alpha += ticker.deltaTime * 0.1;
            } else if (this.container.alpha >= 1) {
                this.container.alpha = 1;
            }
        };

        this.spinTimerFunction = ticker => {
            spinnerHighlight.rotation += (ticker.deltaMS / 1000) * Math.PI * 2 * (1/0.8);
        };
    }

    attachToPixiApp(app) {
        PIXI.Ticker.shared.add(this.fadeInTimerFunction);
        PIXI.Ticker.shared.add(this.spinTimerFunction);
        app.stage.addChild(this.container);
    }

    detachFromPixiApp(app) {
        PIXI.Ticker.shared.remove(this.fadeInTimerFunction);
        PIXI.Ticker.shared.remove(this.spinTimerFunction);
        app.stage.removeChild(this.container);
    }
}